<template>
    <div id="app" class="page">
        <tab-header></tab-header>
        <router-view></router-view>
        <tab-footer></tab-footer>

    </div>
</template>

<script>
import TabHeader from './components/TabHeader.vue';
import TabFooter from './components/TabFooter.vue';
export default {
    data() {
        return {
            user: {},
            loading: false,
            message: '',
        };
    },
    components: {
        TabHeader, TabFooter
    },
}
</script>